module.exports = __webpack_public_path__ + "assets/GoldKappa2x.71fe3b3b8bc2aea3a68e0d4b05b29853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldKappa2x.png
// module id = 812
// module chunks = 0